import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect } from 'react-router-dom'

import { fetch as fetchCellarAction } from 'actions/cellars'

export class Cellar extends React.Component {
  componentDidMount() {
    this.fetchCellarData()
  }

  fetchCellarData() {
    const {
      match,
      fetchCellar,
    } = this.props
    const { lang, cellarId } = match.params

    fetchCellar(cellarId, lang)
  }

  render() {
    const {
      match,
      cellars,
    } = this.props

    const { lang, cellarId } = match.params

    if (!cellars[cellarId] || !cellars[cellarId][lang]) {
      return null
    }

    const cellar = cellars[cellarId][lang]
    const { giftCards } = cellar
    const [giftCard] = giftCards || []

    if (!giftCard) {
      return null
    }

    return (
      <Redirect to={`/${lang}/${cellarId}/gift-cards/${giftCard._id}?lang=${lang}`} />
    )
  }
}

Cellar.propTypes = {
  cellars: PropTypes.object.isRequired,
  fetchCellar: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    cellars: state.cellars,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCellar: fetchCellarAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Cellar)
